import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChartCompareHorizontal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChartCompareHorizontal"><Path d="M5 19H21V21H3V3H5V19Z" fill="currentColor"/><Path d="M11 18H6V16H11V18Z" fill="currentColor"/><Path d="M19 15H6V13H19V15Z" fill="currentColor"/><Path d="M13 10H6V8H13V10Z" fill="currentColor"/><Path d="M16 7H6V5H16V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChartCompareHorizontal;
